class Header {
  constructor () {
    this.initHeader()
  }

  initHeader () {
    const header = document.getElementById('header')
    const headerHeight = header.offsetHeight + 60
    let distanceToTop = document.documentElement.scrollTop
    const ctaUserButton = document.querySelector('.c-header__icon__user')
    const ctaPhoneButton = document.querySelector('.c-header__icon__phone')
    const ctaMatricula = document.querySelector('.c-ctaBanner__link')

    function getCookie (name) {
      var dc = document.cookie
      var prefix = name + '='
      var begin = dc.indexOf('; ' + prefix)
      if (begin === -1) {
        begin = dc.indexOf(prefix)
        if (begin !== 0) return null
      } else {
        begin += 2
        var end = document.cookie.indexOf(';', begin)
        if (end === -1) {
          end = dc.length
        }
      }
      return decodeURI(dc.substring(begin + prefix.length, end))
    }

    var gaCookie = getCookie('_ga')

    if (gaCookie != null) {
      if (ctaUserButton) {
        ctaUserButton.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'cta_user'
          })
        })
      }

      if (ctaPhoneButton) {
        ctaPhoneButton.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'cta_phone'
          })
        })
      }

      if (ctaMatricula) {
        ctaMatricula.addEventListener('click', function () {
          window.dataLayer.push({
            event: 'cta_simulate_registration'
          })
        })
      }
    }

    // Menu button event listener
    const mobileMenuToogler = document.getElementById('main-menu-toggler')
    if (mobileMenuToogler) { mobileMenuToogler.addEventListener('click', blockScroll) }

    // Scroll event listener
    window.addEventListener('scroll', throttle(callback, 200))

    if (distanceToTop > 0) {
      header.classList.add('scrolled')
    }

    function blockScroll () {
      const body = document.body
      header.classList.toggle('toggled')
      if (!this.classList.contains('menu-item-has-children')) {
        if (body.classList.contains('u-mobile-block-scroll')) {
          document.body.classList.remove('u-mobile-block-scroll')
        } else {
          document.body.classList.add('u-mobile-block-scroll')
        }
      }
    }

    function throttle (callback, wait = 100) {
      let timer = null

      return function (args) {
        if (timer === null) {
          timer = setTimeout(() => {
            callback.apply(this, args)
            timer = null
          }, wait)
        }
      }
    }

    function callback () {
      const newDistanceToTop = document.documentElement.scrollTop

      if (newDistanceToTop <= headerHeight) {
        header.classList.remove('scrolled', 'scrolled--show', 'fixed')
      } else if (newDistanceToTop < distanceToTop && newDistanceToTop > headerHeight) {
        header.classList.add('scrolled--show')
        header.classList.add('fixed')
      } else {
        header.classList.add('scrolled')
        header.classList.remove('scrolled--show')
      }
      distanceToTop = newDistanceToTop
    }
  }
}

export default Header
